import { Modal } from 'antd';
import { useVicinityMapQuery } from 'lib/hooks/queries';
import useWindowDimensions from 'lib/hooks/useWindowDimensions';

type Props = {
  showSiteMapModal: boolean;
  setShowSiteMapModal: (showSiteMapModal: boolean) => void;
};

const SiteMapModal = ({ showSiteMapModal, setShowSiteMapModal }: Props) => {
  const windowDimensions = useWindowDimensions();
  const vicinityMapData = useVicinityMapQuery().data!;
  const communityId = vicinityMapData.community.applicationID;
  const BASE_LAUNCH_URL = vicinityMapData.systemProperties.BASE_LAUNCH_URL;

  return (
    <Modal
      title="Site Map"
      width={windowDimensions.width * 0.96}
      centered
      visible={showSiteMapModal}
      footer={null}
      onCancel={() => setShowSiteMapModal(false)}
    >
      <iframe
        title="site-map"
        src={BASE_LAUNCH_URL + '/?app=sp&communityId=' + communityId}
        width="100%"
        height={windowDimensions.height * 0.8}
        frameBorder="0"
      />
    </Modal>
  );
};

export default SiteMapModal;
